import { SAGA_ACTIONS } from "_config";
import { LoginReq, LoginWithOtpReq, UpdateUserProfile } from "_common/interfaces/ApiReqRes";
import { useApiCall } from "../common/appApiCallHook";

export function useUserApi() {
  const callApi = useApiCall();

  const login = (data: LoginReq, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError);
  };

  const registration = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.REGISTRATION, data, onSuccess, onError);
  };
  const forgotPassword = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.FORGOT_PASSWORD, data, onSuccess, onError);
  };

  const resetPassword = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.RESET_PASSWORD, data, onSuccess, onError);
  };

  const loginWithOtp = (data: LoginWithOtpReq, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGIN_WITH_OTP, data, onSuccess, onError);
  };

  const loginWithEmail = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGIN_WITH_EMAIL, data, onSuccess, onError);
  };

  const updateUserProfile = (data: UpdateUserProfile, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_PROFILE, data, onSuccess, onError);
  };

  const getMe = (onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.DETAILS, null, onSuccess, onError);
  };

  const logout = (onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGOUT, null, onSuccess, onError);
  };

  const updateDisplayName = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_DISPLAY_NAME, data, onSuccess, onError);
  };

  const checkValidToken = (onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.CHECK_VALID_TOKEN, null, onSuccess, onError);
  };

  const createUpdateUserGame = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.CREATE_UPDATE_USER_GAME, data, onSuccess, onError);
  };

  const saveNotification = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.SAVE_NOTIFICATION, data, onSuccess, onError);
  };

  const getRegistrationFieldsData = (data: any, onSuccess: (message: string, resp: any) => void, onError: (message: string, resp: any) => void) => {
    callApi(SAGA_ACTIONS.USER.REGISTRATION_FIELDS, data, onSuccess, onError);
  };

  return {
    callLogin: login,
    callLoginWithOtp: loginWithOtp,
    callUpdateUserProfile: updateUserProfile,
    callLogout: logout,
    callGetMe: getMe,
    callRegistration: registration,
    callLoginWithEmail: loginWithEmail,
    callForgotPassword: forgotPassword,
    callResetPassword: resetPassword,
    callUpdateDisplayName: updateDisplayName,
    callCheckValidToken: checkValidToken,
    callCreateUpdateUserGame: createUpdateUserGame,
    callSaveNotification: saveNotification,
    callGetRegistrationFieldsData: getRegistrationFieldsData,
  };
}
